module.exports = __webpack_public_path__ + "static/map-fr-91d2acd8ae674a16917a8d0d949bc856.png";